import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Field, reduxForm } from "redux-form";

import "./CanteenReport.css"

import history from "../../../../history";
import { makeCanteenReportCSV, downloadFile } from "../../../../helpers/csvCreator";
import { getMeals } from "../../../../actions/mealActions";
import { resetCanteenReport, getCanteenReport, newCanteenReport } from "../../../../actions/canteenReportActions";

import Form from "../../../CustomViews/Form";

const CanteenReportForm = reduxForm({ form: "canteenReportForm" })(Form);

class CanteenReport extends React.Component {
    componentDidMount() {
        if (this.props.mode === "selected") this.props.getCanteenReport(this.props.match.params.reportID);
        else this.props.resetCanteenReport();
        this.props.getMeals();
    }

    componentDidUpdate() {
        if (this.props.currentUser.userID && this.props.currentUser.ouID !== +process.env.REACT_APP_HR_OU_ID) history.push("/");
        if (this.props.mode === "new" && this.props.newReportID !== null && this.props.currentReport.reportID !== this.props.newReportID) this.props.getCanteenReport(this.props.newReportID);
    }

    exportFile = () => {
        const reportData = [
            ...this.props.currentReport.content,
            ...Object.values(this.props.currentReport.externalContent).flatMap(entry => ([
                { userID: "" },
                { userID: entry.externalOuName },
                ...entry.content
            ])),
            ...(this.props.currentReport.outsideContent.length ? [
                { userID: "" },
                { userID: "Pozostali" },
                ...this.props.currentReport.outsideContent
            ] : [])
        ];
        const data = makeCanteenReportCSV(reportData, this.props.meals.map(meal => ({ value: meal.code, label: meal.description })));
        downloadFile(data, `Zestawienie_${this.props.currentReport.dateFrom}_${this.props.currentReport.dateTo}`);
    };

    renderFieldError = (name, formErrors, renderError) => {
        const error = formErrors.filter(err => err.field === name)[0];
        return renderError(error);
    };

    renderFields = (_, __, ___, renderInput, formErrors, renderError) => {
        return (
            <React.Fragment>
                <div className="ui segments">
                    <div className="ui segment">
                        <div className="ui header">
                            <i className="table icon"></i>
                            Nowe zestawienie
                        </div>
                    </div>
                    <div className="ui segment">
                        <div className="ui grid">
                            <div className="two columns row">
                                <div className="column">
                                    <div className="content">
                                        <b>Od dnia:</b><br />
                                        <Field type="date" name="dateFrom" component={(input) => renderInput(input, false)} placeholder="Od dnia..." />
                                        {this.renderFieldError("dateFrom", formErrors, renderError)}
                                    </div>
                                </div>
                                <div className="column">
                                    <div className="content">
                                        <b>Do dnia:</b><br />
                                        <Field type="date" name="dateTo" component={(input) => renderInput(input, false)} placeholder="Do dnia..." />
                                        {this.renderFieldError("dateTo", formErrors, renderError)}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="sixteen wide column">
                                    <div className="content">
                                        {this.renderFieldError("period", formErrors, renderError)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ui segment">
                        <div className="content">Data wygenerowania <b>{new Date().toLocaleDateString("en-CA")}</b></div>
                    </div>
                </div>
                <button className="ui button primary">Zatwierdź</button>
            </React.Fragment>
        );
    };

    renderCanteenReport = () => {
        return (
            <React.Fragment>
                <div className="ui large header">
                    <div className="content">
                        Zestawienie nr: {this.props.currentReport.reportID}<br />
                        za okres od: {this.props.currentReport.dateFrom} do: {this.props.currentReport.dateTo}
                    </div>
                </div>
                <div className="content container">
                    <table className="content">
                        <tbody>
                            {this.renderRow()}
                            {this.renderRows()}
                        </tbody>
                    </table>
                </div>
                <div className="ui legend grid">
                    <div className="row">
                        <div className="twelve wide column">
                            <div className="legend content">
                                <b>Legenda:</b>
                                {this.props.meals.map(meal => {
                                    return (<React.Fragment key={meal.mealID}><br /><b>{meal.code}</b> &mdash; {meal.description}</React.Fragment>);
                                })}
                            </div>
                        </div>
                        <div className="four wide right aligned column">
                            <button className="ui primary button" type="button" onClick={this.exportFile}>Pobierz do csv</button>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    };

    renderRows = () => {
        const summary = {
            totalPrice: 0.0,
            foundedPrice: 0.0
        };
        let guestRow = null;
        let internRow = null;
        const outsideSummary = {
            totalPrice: 0.0,
            foundedPrice: 0.0
        };
        return (
            <React.Fragment>
                {this.props.currentReport.content.map((row, index) => {
                    if (row.userID !== -7) return this.renderRow(row, index, summary);
                    else {
                        if (row.lname === "Praktykant") internRow = row;
                        else guestRow = row;
                        return null;
                    }
                })}
                {this.renderRow(null, null, summary)}
                {guestRow ? (
                    <React.Fragment>
                        <tr className="empty"><td colSpan={this.props.meals.length + 5}/></tr>
                        {this.renderRow(guestRow, -1, null, true)}
                    </React.Fragment>
                ) : null}
                {internRow ? (
                    <React.Fragment>
                        <tr className="empty"><td colSpan={this.props.meals.length + 5}/></tr>
                        {this.renderRow(internRow, -2, null, true)}
                    </React.Fragment>
                ) : null}
                {Object.keys(this.props.currentReport.externalContent).length ? (
                    <React.Fragment>
                        <tr className="empty"><td colSpan={this.props.meals.length + 5}/></tr>
                        <tr className="empty"><td colSpan={this.props.meals.length + 5}>
                            <div className="ui medium header">
                                <div className="content">Pracownicy zewnętrzni:</div>
                            </div>
                        </td></tr>
                        {this.renderRow()}
                        {this.renderExternalRows()}
                    </React.Fragment>
                ) : null}
                {this.props.currentReport.outsideContent.length ? (
                    <React.Fragment>
                        <tr className="empty"><td colSpan={this.props.meals.length + 5}/></tr>
                        <tr className="empty"><td colSpan={this.props.meals.length + 5}>
                            <div className="ui medium header">
                                <div className="content">Pozostali:</div>
                            </div>
                        </td></tr>
                        {this.renderRow()}
                        {this.props.currentReport.outsideContent.map((row, index) => this.renderRow(row, index, outsideSummary))}
                        {this.renderRow(null, null, outsideSummary)}
                    </React.Fragment>
                ) : null}
            </React.Fragment>
        );
    };

    renderExternalRows = () => Object.keys(this.props.currentReport.externalContent).map((key, index) => {
        const externalSummary = {};
        if (!externalSummary[key]) externalSummary[key] = {
            totalPrice: 0.0,
            foundedPrice: 0.0
        };
        const externalContent = this.props.currentReport.externalContent[key];
        return (
            <React.Fragment key={key}>
                {index > 0 ? (
                    <tr className="empty"><td colSpan={this.props.meals.length + 5}/></tr>
                ) : null}
                {this.renderRow({ lname: externalContent.externalOuName }, null, null, false, true)}
                {externalContent.content.map((row, index) => this.renderRow(row, index, externalSummary[key]))}
                {this.renderRow(null, null, externalSummary[key])}
            </React.Fragment>
        );
    });

    renderRow = (row = null, index = null, summary = null, guest = false, external = false) => {
        if (row && summary) {
            summary.totalPrice = Math.round((summary.totalPrice + +row.totalPrice) * 100) / 100;
            summary.foundedPrice = Math.round((summary.foundedPrice + +row.foundedPrice) * 100) / 100;
        }
        return (
            <tr key={row ? index : (summary ? "footer" : "header")}>
                {row && !summary && !guest && external ? (
                    <td colSpan={6 + this.props.meals.length} className="center footer">{row.lname}</td>
                ) : (
                    <React.Fragment>
                        {(row === null  && summary) || guest ? (
                            <td colSpan={3} className="center footer">{summary ? "Razem" : row.lname}</td>
                        ) : (
                            <React.Fragment>
                                <td className={`${row ? "content" : "header"}`}>{row ? `${index + 1}.` : "Lp."}</td>
                                <td className={`wide ${row ? "content" : "header"}`}>{row ? row.lname : "Nazwisko"}</td>
                                <td className={`wide ${row ? "content" : "header"}`}>{row ? row.fname : "Imię"}</td>
                            </React.Fragment>
                        )}
                        {this.props.meals.map(meal => {
                            if (row && summary) {
                                if (meal.code in summary) summary[meal.code] += +row[meal.code];
                                else summary[meal.code] = +row[meal.code];
                            }
                            return (<td className={`narrow center ${(row && !guest) ? "content" : ((summary || guest) ? "footer" : "header")}`} key={`${index}${meal.code}`}>{row ? row[meal.code] : (summary ? summary[meal.code] : meal.code)}</td>);
                        })}
                        <td className={`middle right ${(row && !guest) ? "content" : ((summary || guest) ? "footer" : "header")}`}>{row ? row.totalPrice : (summary ? (summary.totalPrice).toFixed(2) : "Łączny koszt")}</td>
                        <td className={`middle right ${(row && !guest) ? "content" : ((summary || guest) ? "footer" : "header")}`}>{row ? row.foundedPrice : (summary ? (summary.foundedPrice).toFixed(2) : "Łączny koszt po dofinansowaniu")}</td>
                    </React.Fragment>
                )}
            </tr>
        );
    };

    render() {
        return (
            <React.Fragment>
                <div className="canteen-report-component ui container">
                    <div className={`ui ${this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? "four" : "two"} item menu`}>
                        <Link to="/meal-reservations/my" className="item">
                            <div className="content">Rezerwacje</div>
                        </Link>
                        <Link to="/meal-orders/my" className="item">
                            <div className="content">Moje zamówienia</div>
                        </Link>
                        {this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? (
                            <React.Fragment>
                                <Link to="/meal-orders/today" className="item">
                                    <div className="content">Korekty zamówień</div>
                                </Link>
                                <Link to="/meal-orders/reports" className="active item">
                                    <div className="content">Zestawienia</div>
                                </Link>
                            </React.Fragment>
                        ) : null}
                    </div>
                    {this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? (
                        <div className="ui three item menu">
                            <Link to="/meal-orders/unsettled" className="item">
                                <div className="content">Nierozliczone zamówienia</div>
                            </Link>
                            <Link to="/meal-orders/reports" className="item">
                                <div className="content">Wygenerowane zestawienia</div>
                            </Link>
                            <Link to={`/meal-orders/reports/${this.props.mode === "new" ? "new" : `details/${this.props.match.params.reportID}`}`} className="active item">
                                <div className="content">{this.props.mode === "new" ? "Nowe zestawienie" : "Podgląd zestawienia"}</div>
                            </Link>
                        </div>
                    ) : null}
                    <div className="ui divider" />
                    <div className="ui container">
                        {this.props.mode === "new" ? (
                            <React.Fragment>
                                <CanteenReportForm onSubmit={this.props.newCanteenReport} renderFields={this.renderFields} />
                                {this.props.currentReport.reportID !== null ? <div className="ui divider" /> : null}
                            </React.Fragment>
                        ) : null}
                        {this.props.currentReport.reportID !== null ? this.renderCanteenReport() : null}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.current,
    currentReport: state.canteenReport.current,
    newReportID: state.canteenReport.reportID,
    meals: state.meal.list
});

export default connect(mapStateToProps, { getMeals, resetCanteenReport, getCanteenReport, newCanteenReport })(CanteenReport);